export const DEFAULT_CHECKOUT_CONFIRMATION_EMAIL_SUBJECT =
  "Your Order with {{artist.name}}";

export const DEFAULT_CHECKOUT_CONFIRMATION_EMAIL_HTML = `<table width="100%" border="0" cellspacing="0" cellpadding="0">
  <tr>
    <td align="center">
      <div style="max-width: 600px; margin: 0 auto; text-align: left; width: 100%;">
        <p style="font-family: Arial, sans-serif; font-size: 16px; line-height: 1.5; color: #333333;">
          Hi {{firstName}},
        </p>
        <p style="font-family: Arial, sans-serif; font-size: 16px; line-height: 1.5; color: #333333;">
          Thank you for your order!
        </p>
        {{#if orderUrl}}
        <p style="font-family: Arial, sans-serif; font-size: 16px; line-height: 1.5; color: #333333;">
          <a href="{{orderUrl}}">View order</a>
        </p>
        {{/if}}
        {{{orderSummary}}}
      </div>
    </td>
  </tr>
</table>`;

export function resolveCheckoutConfirmationEmailTemplate({
  subject,
  html,
}: {
  subject?: string;
  html?: string;
}): { subject: string; html: string } {
  const resolvedSubject = subject?.trim() || DEFAULT_CHECKOUT_CONFIRMATION_EMAIL_SUBJECT;
  const resolvedHtml = html?.trim() || DEFAULT_CHECKOUT_CONFIRMATION_EMAIL_HTML;
  return { subject: resolvedSubject, html: resolvedHtml };
}
